var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "23",
          height: "16",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#047AB1",
          d:
            "M.205 16h4.518c1.028 0 2.26-1.195 2.26-2.133V0H2.463C1.436 0 .205 1.195.205 3.2V16Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#fff",
          d:
            "M2.77 10.816c-.868 0-1.731-.115-2.565-.341V9.3c.647.378 1.386.591 2.146.619.87 0 1.356-.576 1.356-1.365V5.333h2.146v3.222c0 1.258-.7 2.261-3.084 2.261Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#D42D06",
          d:
            "M8.112 16h4.518c1.027 0 2.258-1.195 2.258-2.133V0H10.37C9.344 0 8.113 1.195 8.113 3.2V16Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#fff",
          d:
            "M8.112 6.08c.655-.597 1.784-.97 3.614-.885.994.042 2.033.32 2.033.32v1.184a4.785 4.785 0 0 0-1.954-.608c-1.39-.118-2.236.618-2.236 1.909 0 1.29.847 2.027 2.236 1.92a4.853 4.853 0 0 0 1.954-.619v1.174s-1.04.288-2.033.33c-1.83.086-2.96-.288-3.614-.885V6.08Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#67B637",
          d:
            "M16.018 16h4.518c1.027 0 2.259-1.195 2.259-2.133V0h-4.518c-1.028 0-2.26 1.195-2.26 3.2V16Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#fff",
          d:
            "M21.665 9.28c0 .853-.7 1.387-1.637 1.387h-4.01V5.333h3.648l.26.011c.824.043 1.434.501 1.434 1.29 0 .62-.418 1.153-1.174 1.28v.033c.835.053 1.48.554 1.48 1.333Zm-2.88-3.104a1.086 1.086 0 0 0-.147-.01h-1.355v1.343h1.502a.667.667 0 0 0 .52-.672c0-.362-.238-.608-.52-.661Zm.17 2.176a1.03 1.03 0 0 0-.181-.01h-1.491v1.46h1.49l.181-.02c.283-.065.52-.342.52-.715 0-.374-.226-.64-.52-.715Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }